// extracted by mini-css-extract-plugin
module.exports = {"link":"BaseLink_link_1H12g"};